var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94733 0.719966C1.61623 0.404542 1.07942 0.404542 0.748323 0.719965C0.417227 1.03539 0.417227 1.54679 0.748323 1.86221L6.4005 7.24683C6.73159 7.56225 7.26841 7.56225 7.5995 7.24683L13.2517 1.86222C13.5828 1.54679 13.5828 1.03539 13.2517 0.719966C12.9206 0.404543 12.3838 0.404543 12.0527 0.719966L7 5.53346L1.94733 0.719966Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDefault);
export default __webpack_public_path__ + "static/media/ArrowDefault.237ec22fe37434c3575abd29003d8806.svg";
export { ForwardRef as ReactComponent };